import { useTranslation } from 'react-i18next';
import Tooltip from '@material-ui/core/Tooltip';
import { Info } from '@material-ui/icons';
import CardWrapper from 'components/Card/CardWrapper';
import FormTextInputTranslatable from 'components/FormTextInput/FormTextInputTranslatable';
import { makeStyles } from '@material-ui/styles';
import CustomFormLabel from 'components/CustomFormLabel/CustomFormLabel';

import GridContainer from '../../../components/Grid/GridContainer';
import GridItem from '../../../components/Grid/GridItem';
import FormImageUpload from '../../../components/FormImageUpload/FormImageUpload';
import FormTextInput from '../../../components/FormTextInput/FormTextInput';
import CardBody from '../../../components/Card/CardBody';

const useStyles = makeStyles({
  dietPhoto: {
    marginBottom: '0.5rem',
  },
  dietIconWrapper: { textAlign: 'center' },
  dietIconLabel: { marginTop: '10px' },
  dietIconTooltip: {
    marginLeft: '10px',
  },
});

const ClientsPanelInterface = ({
  handleInputChange,
  state,
  getImage,
  removeImage,
}) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <CardWrapper title={t('form.basicInfo.clientPanelView')}>
      <CardBody>
        <GridContainer>
          <GridItem xs={12} sm={6}>
            <FormTextInputTranslatable
              label={t('form.field.description')}
              name="description"
              value={state.description}
              handleChange={handleInputChange}
              inputSize={6}
              multiline={true}
              maxLength={2000}
              isRequired={false}
            />
            <FormTextInput
              label={t('form.field.orderInOrderForm')}
              name="position"
              value={state.position}
              type="number"
              handleChange={handleInputChange}
              inputSize={6}
            />
          </GridItem>
          <GridItem xs={12} sm={6}>
            <GridContainer>
              <GridItem xs={12} lg={6}>
                <FormImageUpload
                  label={
                    <span className={classes.dietPhoto}>
                      {t('form.field.dietPhoto')}
                    </span>
                  }
                  stateName="clientImage"
                  getImage={getImage}
                  removeImage={removeImage}
                  previewUrl={state.clientImageUrl}
                />
              </GridItem>
              <GridItem className={classes.dietIconWrapper} xs={12} lg={6}>
                <CustomFormLabel className={classes.dietIconLabel}>
                  {t('form.field.dietIcon')}
                  <Tooltip
                    title={
                      <>
                        <p>{t('form.dietIconInfo1')}</p>
                        {t('form.dietIconInfo2')}
                      </>
                    }
                    placement="right"
                  >
                    <Info
                      fontSize="small"
                      className={classes.dietIconTooltip}
                    />
                  </Tooltip>
                </CustomFormLabel>
                <FormImageUpload
                  buttonText={t('form.field.selectIcon')}
                  isIcon={true}
                  stateName="mainImage"
                  getImage={getImage}
                  removeImage={removeImage}
                  previewUrl={state.mainImageUrl}
                />
              </GridItem>
            </GridContainer>
          </GridItem>
        </GridContainer>
      </CardBody>
    </CardWrapper>
  );
};

export default ClientsPanelInterface;
